module.exports = __webpack_public_path__ + "img/scorching-plan.200f14df.svg";